import { format } from 'date-fns';
import { useRemindModal } from './hooks';
import { RemindModalPresentation } from './presentations';

type Props = {
  threeLetterCode: string;
  stressAssessmentId: number;
  onClose: () => void;
};

export const RemindModal: React.FC<Props> = ({ threeLetterCode, stressAssessmentId, onClose }) => {
  const { handleRemind, dueDate, pendingCount } = useRemindModal({
    threeLetterCode,
    stressAssessmentId,
  });

  const dueDateLabel = dueDate ? format(new Date(dueDate * 1000), 'yyyy/MM/dd') : '-';

  return (
    <RemindModalPresentation
      pendingCount={pendingCount}
      dueDateLabel={dueDateLabel}
      onClose={onClose}
      onConfirm={handleRemind}
    />
  );
};
